import { Branding } from "@/models";

export default (inspectionType: string, skill: string, branding: number) => {
  if (skill.substr(0, 1).toUpperCase() != "B") { return "Ordinary"; }
  if (branding == Branding.Vulcan && skill.toUpperCase() == "B01") { return "Ordinary"; }

  switch (inspectionType.toUpperCase()) {
    case "I": return "Interim";
    case "T": return "Thorough";
  }

  return "Ordinary";
};